export const getRadiusInMeters = (radiusInMiles) => radiusInMiles * 1609.34;

export const getUserLocationAndInitMap = ({ successFn, errorFn }) => {
  navigator.geolocation.getCurrentPosition(successFn, errorFn);
};

export const useBrowserCoords = (coords, browserLatLon) =>
  coords?.length !== 2 && browserLatLon?.length === 2;
